<app-base-uploader
  [size]="size"
  [label]="label"
  [uploadLabel]="'common.file.uploadImage' | transloco"
  [isDisabled]="isDisabled"
  [isRequired]="isRequired"
  [isClearable]="isClearable"
  [labelCssClass]="labelCssClass"
  [value]="value"
  [isValueExist]="!!value"
  (clear)="onClear()"
  (upload)="onUpload()"
>
  <img
    *ngIf="value"
    [src]="value"
    ngProjectAs="image"
    class="uploader-media"
    alt="Uploaded image"
    data-holder-rendered="true"
  />

  <ng-content select="settings" ngProjectAs="settings" />
</app-base-uploader>
